import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { Card, CardContent, CardHeader } from '../components/Card';
import { CalendarIcon, ClockIcon, MapPinIcon, ChevronRightIcon } from 'lucide-react';
export const Bookings = () => {
  const navigate = useNavigate();
  // Mock data for bookings
  const bookings = [{
    id: 'b123',
    eventName: 'Summer Club Night',
    tableName: 'VIP Table',
    date: 'Saturday, 15 July 2023',
    time: '22:00 - 05:00',
    location: 'Club XYZ, Berlin',
    status: 'upcoming',
    guestRequests: 2
  }, {
    id: 'b124',
    eventName: 'Rooftop Party',
    tableName: 'Lounge Area',
    date: 'Friday, 21 July 2023',
    time: '20:00 - 02:00',
    location: 'Skybar, Munich',
    status: 'upcoming',
    guestRequests: 0
  }, {
    id: 'b120',
    eventName: 'Beach Club Opening',
    tableName: 'Beach Table',
    date: 'Saturday, 1 July 2023',
    time: '14:00 - 22:00',
    location: 'Beach Club, Hamburg',
    status: 'past',
    guestRequests: 0
  }];
  const handleViewBooking = (id: string) => {
    navigate(`/guest-requests/${id}`);
  };
  return <div className="bg-white min-h-screen pb-16" data-id="element-214">
      <Header title="My Bookings" data-id="element-215" />
      <div className="p-4" data-id="element-216">
        <h2 className="text-xl font-bold text-gray-800 mb-3" data-id="element-217">
          Upcoming Bookings
        </h2>
        {bookings.filter(booking => booking.status === 'upcoming').map(booking => <Card key={booking.id} variant="outlined" isClickable className="mb-4" onClick={() => handleViewBooking(booking.id)} data-id="element-218">
              <CardContent data-id="element-219">
                <div className="p-3" data-id="element-220">
                  <div className="flex justify-between items-start mb-2" data-id="element-221">
                    <h3 className="font-medium text-gray-800" data-id="element-222">
                      {booking.eventName}
                    </h3>
                    <ChevronRightIcon className="h-5 w-5 text-gray-400" data-id="element-223" />
                  </div>
                  <p className="text-sm text-gray-700 mb-1" data-id="element-224">
                    {booking.tableName}
                  </p>
                  <div className="flex items-center text-sm text-gray-600 mb-1" data-id="element-225">
                    <CalendarIcon className="h-4 w-4 mr-1" data-id="element-226" />
                    <span data-id="element-227">{booking.date}</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-600 mb-1" data-id="element-228">
                    <ClockIcon className="h-4 w-4 mr-1" data-id="element-229" />
                    <span data-id="element-230">{booking.time}</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-600" data-id="element-231">
                    <MapPinIcon className="h-4 w-4 mr-1" data-id="element-232" />
                    <span data-id="element-233">{booking.location}</span>
                  </div>
                  {booking.guestRequests > 0 && <div className="mt-2 pt-2 border-t border-dashed border-gray-200" data-id="element-234">
                      <div className="inline-block px-2 py-1 bg-gray-100 rounded-md text-sm" data-id="element-235">
                        {booking.guestRequests} pending guest requests
                      </div>
                    </div>}
                </div>
              </CardContent>
            </Card>)}
        <h2 className="text-xl font-bold text-gray-800 mb-3 mt-6" data-id="element-236">
          Past Bookings
        </h2>
        {bookings.filter(booking => booking.status === 'past').map(booking => <Card key={booking.id} variant="outlined" isClickable className="mb-4 opacity-70" onClick={() => handleViewBooking(booking.id)} data-id="element-237">
              <CardContent data-id="element-238">
                <div className="p-3" data-id="element-239">
                  <div className="flex justify-between items-start mb-2" data-id="element-240">
                    <h3 className="font-medium text-gray-800" data-id="element-241">
                      {booking.eventName}
                    </h3>
                    <ChevronRightIcon className="h-5 w-5 text-gray-400" data-id="element-242" />
                  </div>
                  <p className="text-sm text-gray-700 mb-1" data-id="element-243">
                    {booking.tableName}
                  </p>
                  <div className="flex items-center text-sm text-gray-600 mb-1" data-id="element-244">
                    <CalendarIcon className="h-4 w-4 mr-1" data-id="element-245" />
                    <span data-id="element-246">{booking.date}</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-600 mb-1" data-id="element-247">
                    <ClockIcon className="h-4 w-4 mr-1" data-id="element-248" />
                    <span data-id="element-249">{booking.time}</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-600" data-id="element-250">
                    <MapPinIcon className="h-4 w-4 mr-1" data-id="element-251" />
                    <span data-id="element-252">{booking.location}</span>
                  </div>
                </div>
              </CardContent>
            </Card>)}
      </div>
      <Navigation data-id="element-253" />
    </div>;
};